import {useMemo} from 'react'
import {useTable, ColumnInstance, Row} from 'react-table'
import {CustomHeaderColumn} from './columns/CustomHeaderColumn'
import {CustomRow} from './columns/CustomRow'
import {useQueryResponseData, useQueryResponseLoading} from '../core/QueryResponseProvider'
import {operatorsColumns} from './columns/_columns'
import {Company} from '../core/_models'
import {OperatorsListLoading} from '../components/loading/OperatorsListLoading'
import {OperatorsListPagination} from '../components/pagination/OperatorsListPagination'
import {TOKENS} from '../../../../../components/design-system'

type PropTypes = {
  hiddenColumns?: string[]
}

const CompanyTable = ({hiddenColumns = []}: PropTypes) => {
  const rowsRaw = useQueryResponseData()
  const isLoading = useQueryResponseLoading()
  const data = useMemo(() => rowsRaw, [rowsRaw])
  const cols = useMemo(() => operatorsColumns, [])
  const {getTableProps, getTableBodyProps, headers, rows, prepareRow} = useTable({ columns: cols, data })

  return (
    <div style={{ position: 'relative' }}>
      <div style={{ overflowX: 'auto' }}>
        <table
          id='kt_table_users'
          {...getTableProps()}
          style={{
            width: '100%',
            borderCollapse: 'separate',
            borderSpacing: 0,
            fontSize: 13,
            color: TOKENS.color.text,
          }}
        >
          <thead>
            <tr style={{
              fontSize: TOKENS.typography.label.size,
              fontWeight: TOKENS.typography.label.weight,
              textTransform: TOKENS.typography.label.transform,
              letterSpacing: TOKENS.typography.label.tracking,
              color: TOKENS.color.muted,            }}>
              {headers
                .filter((column: ColumnInstance<Company>) => !hiddenColumns.includes(column.id))
                .map((column: ColumnInstance<Company>) => (
                  <CustomHeaderColumn key={column.id} column={column} />
                ))}
            </tr>
          </thead>
          <tbody {...getTableBodyProps()}>
            {rows.length > 0
              ? rows.map((row: Row<Company>, i) => {
                  prepareRow(row)
                  return (
                    <CustomRow row={row} index={i} key={`row-${i}-${row.id}`} hiddenColumns={hiddenColumns} />
                  )
                })
              : !isLoading && (
                  <tr>
                    <td colSpan={7} style={{
                      padding: '40px 16px',
                      textAlign: 'center',
                      color: TOKENS.color.muted,
                      fontSize: 13,
                    }}>
                      Nenhum registro correspondente encontrado.
                    </td>
                  </tr>
                )}
          </tbody>
        </table>
      </div>
      <div style={{ padding: '12px 18px', borderTop: `1px solid ${TOKENS.color.border}` }}>
        <OperatorsListPagination />
      </div>
      {isLoading && <OperatorsListLoading />}
    </div>
  )
}

export {CompanyTable}
